/**
 * 로그인 후 복귀 경로가 앱 내부 경로인지 검증한다 (오픈 리다이렉트/피싱 방지).
 *
 * `?redirect=` 값은 외부에서 조작 가능한 입력이므로 window.location으로 이동하기 전
 * 반드시 이 함수를 거친다. 반드시 단일 '/'로 시작하는 상대 경로만 허용하고,
 * 절대 URL(https://...), 프로토콜 상대(//evil.com), 백슬래시 트릭(/\evil.com)은
 * 홈('/')으로 폴백한다.
 *
 * 브라우저 URL 파서(WHATWG)는 tab(0x09)/LF(0x0A)/CR(0x0D)을 위치 무관하게 제거하므로,
 * 검증 전 동일하게 제거한다. 그렇지 않으면 '/\t/evil.com' 이 검사를 통과한 뒤
 * 브라우저에서 '//evil.com'(프로토콜 상대)로 바뀌어 오픈 리다이렉트가 된다.
 */
export const sanitizeRedirectPath = (raw: string | null | undefined): string => {
  if (raw == null) return '/';
  const stripped = raw.replace(/[\t\n\r]/g, '');
  return /^\/(?![/\\])/.test(stripped) ? stripped : '/';
};
